module.exports = __webpack_public_path__ + "img/web1.4a9a96a1.png";